// import store from '@/store'
// import consts from "@/consts";
import {routesUnits} from "@/router/prometheus/portal/units"
import MD from "@/router/prometheus/portal/md"

const routes = (process.env.VUE_APP_PACKAGE !== 'prometheus.portal.geotab') ? [] : [
    {
        path: 'login',
        name: 'Login',
        meta: {isGuest: true, hideMap: true},
        component: () => import('@/views/geotab/LoginPage.vue')
    },
    {
        path: 'logout',
        name: 'Logout',
        meta: {hideMap: true},
        component: () => import('@/views/LogoutPage.vue')
    },
    ...MD,
    ...routesUnits.map(r => {
        return {
            ...r,
            meta: {
                ...r.meta,
                // showAsideMenu: false,
            }
        }
    }),
]

export default routes